'use strict';

export default {
  isLoggedIn: state => !!state.currentUser,
  currentUser: state => state.currentUser,

  getCachedPool: state => {
    return id => {
      return (state.pools.find(({pool}) => parseInt(pool.id) === parseInt(id)) || {}).pool;
    };
  },
  getCachedPoolUpdatedAt: state => {
    return id => {
      return (state.pools.find(({pool}) => pool.id === id) || {}).updatedAt;
    };
  }
};
